// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__2fedS","ant-page-header-heading-title":"styles_ant-page-header-heading-title__3g69g","table":"styles_table__0w1Yf"};